import {
  FaHome, FaUser, FaImage, FaCartPlus, FaUserEdit, FaFileContract,
} from 'react-icons/fa';
import { RiMailSendFill } from 'react-icons/ri';
import ROLES from '../../Utils/roles';

export const Routes = [
  // OPEN ROUTES
  {
    path: '/',
    name: 'Home',
    icon: <FaHome />,
    roles: [ROLES.User, ROLES.Team, ROLES.Admin],
  },
  {
    path: '/profile',
    name: 'Profile',
    icon: <FaUser />,
    roles: [ROLES.User, ROLES.Team, ROLES.Admin],
  },
  {
    path: '/buy',
    name: 'Buy NFT\'s',
    icon: <FaCartPlus />,
    roles: [ROLES.User, ROLES.Team, ROLES.Admin],
  },
  {
    path: '/gallery',
    name: 'Owned NFT\'s',
    icon: <FaImage />,
    roles: [ROLES.User, ROLES.Team, ROLES.Admin],
  },
  // TEAM MEMBER ROUTES
  {
    path: '/manageWaitlist',
    name: 'Manage Waitlist',
    icon: <FaUserEdit />,
    roles: [ROLES.Team, ROLES.Admin],
  },
  {
    path: '/manageNfts',
    name: 'Manage NFTs',
    icon: <FaUserEdit />,
    roles: [ROLES.Team, ROLES.Admin],
  },
  // ADMIN ROUTES
  {
    path: '/manage',
    name: 'Manage Members',
    icon: <FaUserEdit />,
    roles: [ROLES.Admin],
  },
  {
    path: '/contract',
    name: 'Manage Contract',
    icon: <FaFileContract />,
    roles: [ROLES.Admin],
  },
  {
    path: '/newsletter',
    name: 'Newsletter',
    icon: <RiMailSendFill />,
    roles: [ROLES.Admin],
  },
];
